const pluralize = (string, count = 0, displayCount = false, transform = ((count) => count)) => {
    string = string + (count != 1 ? "s" : "");

    if (displayCount) return `${transform(count)} ${string}`;
        
    return string;
}

export default pluralize;